import PropTypes from 'prop-types';
import React from 'react';
import MultiLineLabel from './MultiLineLabel';
import { oneLineAddress } from 'react/shared/utils/Address';
import addressShape from 'react/signups/card/shapes/AddressShape';

export default function AddressRadioLabel({ address, description }) {
  return <MultiLineLabel primaryText={description} secondaryText={oneLineAddress(address)} />;
}

AddressRadioLabel.propTypes = {
  address: addressShape.isRequired,
  description: PropTypes.string.isRequired,
};
